/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
import * as Sentry from '@sentry/vue';
import axiosUserInstance from '@/helpers/http-common';
import {
  PROMOTIONS_CHANNEL,
  WINNERS_CHANNEL,
} from '../constants/firebase';

const state = () => ({
  firebasePlugin: null,
  token: null,
  APNStoken: null,
  installationId: null,
});

// getters
const getters = {
};

  // actions
const actions = {
  setupFirebase({ commit }, { firebaseInstance }) {
    commit('setFirebasePluginInstance', firebaseInstance);
  },
  onDeviceReadyForFirebase({ state, dispatch, commit, rootState }, { vueRouter }) {
    // Register handlers
    state.firebasePlugin.onMessageReceived((message) => {
      try {
        if (message.messageType === 'notification') {
          dispatch('handleNotificationMessage', { message, vueRouter });
        } else {
          // dispatch('handleDataMessage', { message });
        }
      } catch (e) {
        Sentry.captureMessage(`Exception in onMessageReceived callback: ${e.message}`);
      }
    }, (error) => {
      Sentry.captureException(error);
    });

    state.firebasePlugin.onTokenRefresh((token) => {
      commit('setToken', token);

      dispatch('syncFirebaseDetails');
    }, (error) => {
      Sentry.captureException(error);
    });

    dispatch('checkNotificationPermission', { requested: false }); // Check permission then get token

    if (rootState.device.platform === 'android') {
      dispatch('initAndroid');
    } else if (rootState.device.platform === 'ios') {
      dispatch('initIos');
    }

    dispatch('getInstallationId');
  },
  syncFirebaseDetails({ state, rootState, rootGetters }) {
    if (!rootGetters['device/isBrowser'] && rootGetters['auth/isAuthenticated']) {
      axiosUserInstance.post(`user-device-firebase-info/${rootState.device.uuid}`, {
        fcm_token: state.token,
        apns_token: state.APNStoken,
        fcm_installation_id: state.installationId,
      })
        .then()
        .catch((err) => {
          Sentry.captureException(err);
        });
    }
  },
  promptUserForInput(
    { commit },
    // eslint-disable-next-line camelcase
    { title, msg, cb },
  ) {
    window.navigator.notification.prompt(
      msg,
      (result) => {
        const input = result.input1 || '';
        cb(input.trim());
      },
      title,
      ['Ok'],
    );
  },
  getToken({ commit, state, dispatch }) {
    state.firebasePlugin.getToken((token) => {
      commit('setToken', token);

      dispatch('syncFirebaseDetails');
    }, (error) => {
      Sentry.captureException(error);
    });
  },
  checkNotificationPermission({ commit, state, dispatch }, { requested }) {
    state.firebasePlugin.hasPermission((hasPermission) => {
      if (hasPermission) {
        // Granted
        dispatch('getToken');
      } else if (!requested) {
        // Request permission
        state.firebasePlugin.grantPermission(() => dispatch('checkNotificationPermission', { requested: true }));
      } else {
        // Denied
        // console.log("Notifications won't be shown as permission is denied");
      }
    });
  },
  handleNotificationMessage({ state }, { message, vueRouter }) {
    if (message.tap && message.page) {
      const pageToRedirect = {
        path: message.page,
        query: { },
      };

      if (message.params) {
        pageToRedirect.query = JSON.parse(message.params);
      }

      vueRouter.push(pageToRedirect);
    } else if (message.tap) {
      vueRouter.push('/');
    }
  },
  handleDataMessage({ state }, { message }) {
    console.log(`Data message received: ${JSON.stringify(message)}`);
  },
  initAndroid({ state }) {
    state.firebasePlugin.createChannel(PROMOTIONS_CHANNEL,
      () => { },
      (error) => {
        Sentry.captureException(error);
      },
    );

    state.firebasePlugin.createChannel(WINNERS_CHANNEL,
      () => { },
      (error) => {
        Sentry.captureException(error);
      },
    );
  },
  initIos({ state, commit }) {
    state.firebasePlugin.onApnsTokenReceived((token) => {
      commit('setAPNStoken', token);
    }, (error) => {
      Sentry.captureException(error);
    });
  },
  getInstallationId({ state, commit }) {
    state.firebasePlugin.getInstallationId((id) => {
      commit('setInstallationId', id);
    }, (error) => {
      Sentry.captureException(error);
    });
  },
};

  // mutations
const mutations = {
  setFirebasePluginInstance(state, firebaseInstance) {
    state.firebasePlugin = firebaseInstance;
  },
  setToken(state, token = null) {
    state.token = token;
  },
  setAPNStoken(state, APNStoken = null) {
    state.APNStoken = APNStoken;
  },
  setInstallationId(state, id = null) {
    state.installationId = id;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/firebase.js